import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/*
  Composant ToastProvider :
  Ce composant est responsable de l'affichage des notifications à l'écran.
  Il configure le conteneur ToastContainer de react-toastify avec des options personnalisées.
*/
const ToastProvider: React.FC = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}              // Délai de fermeture automatique des notifications (en ms)
      stacked={true}                // Permet d'empiler plusieurs notifications
      hideProgressBar={false}       // Afficher la barre de progression
      newestOnTop={false}           // Affiche les notifications les plus récentes en bas
      closeOnClick                  // Fermeture de la notification lors d'un clic
      rtl={false}                   // Langue de lecture de gauche à droite (false pour LTR)
      pauseOnFocusLoss={true}       // Pause les notifications lorsque l'application perd le focus
      draggable={true}              // Permet de déplacer la notification
      pauseOnHover={true}           // Pause les notifications lors du survol
      theme="light"                 // Thème clair pour les notifications
      transition={Slide}            // Transition de la notification (utilise Slide)
    />
  );
};

export { ToastProvider };